<mat-grid-list cols="1" rowHeight="400px">
    <mat-grid-tile>
        <mat-spinner></mat-spinner>
    </mat-grid-tile>    
  </mat-grid-list>